module.exports = __webpack_public_path__ + "fonts/RocGroteskWide-Black.3680fe5.woff";